import React from 'react';
import { useAuth } from '../../helpers/AuthContext';
import Alert from '../Alert';

/**
 * Tells a seller whose plan does not include marketplace listing where their products appear.
 * The server owns the predicate: `channel.planDetails` is `Channel.getPlanDetails()` projected into
 * the presence payload, so a missing value (presence still loading) renders nothing rather than
 * warning a paid seller.
 *
 * Only a valid trial gets the storefront claim. A lapsed plan loses its storefront product list too
 * (`Channel.toApi` returns no products unless the plan is valid), so it gets the generic copy.
 */
export default function MarketplaceVisibilityBanner() {
    const { channel } = useAuth();
    const plan = channel?.planDetails;

    if (plan?.isMarketAllowed !== false) return null;

    const marketplaceName = channel.isRed ? 'the Mayhem Red marketplace' : 'the main Mayhem marketplace';
    const isActiveTrial = plan.type === 'trial' && plan.isValid;

    return (
        <Alert type="warning" className="marketplace-visibility-banner" role="status">
            {isActiveTrial ? (
                <p>
                    While you are on the free trial, your products appear only on your individual
                    storefront. They are not listed in {marketplaceName}.{' '}
                    <a href="/account/plan">Upgrade your plan</a> to get listed.
                </p>
            ) : (
                <p>
                    You do not have an active plan, so your products are not listed
                    in {marketplaceName}.{' '}
                    <a href="/account/plan">Choose a plan</a> to get listed.
                </p>
            )}
        </Alert>
    );
}
